// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"a15d7317","824":"2a9531fb","997":"fdf3120a"}[chunkId] + ".chunk.css";
};